 
<template>
    <div id="navigatorDataDashboard">

        <NavbarComponent :loadingStatus="loading">Navigator Data Deleter</NavbarComponent>
  <div class="alert alert-danger" role="alert">
          This tool deletes data from Navigator. Please make sure to double check meters and start and end dates when deleting data. Use at own risk!
        </div>
        <section class="section">
        
    
            <div class="columns">
                <div class="column is-one-quarter">
                    <!-- Left side Tiles -->

                    <!-- Search Tree Tile -->
                    <div class="box">
                        <!-- search -->
                        <div class="field has-addons">
                            <div class="control">
                                <input class="input is-small" type="text" v-on:keyup.enter="searchNavigator" v-model="searchString" style="width:15em">
                            </div>
                            <div class="control">
                                <a class="button is-small is-primary" @click="searchNavigator">
                                    Search {{this.$store.getters.lastSelectedTreeName}}
                                </a>
                            </div>
                        </div>

                        <div class="field has-addons">
                            <div class="control">
                                <input class="input is-small" type="text" v-model="searchFilter" placeholder="Filter with *"
                                    style="width:15em">
                            </div>
                            <div class="control">
                                <a class="button is-small is-primary" @click="addSearchMeters">
                                    Add All Meters
                                </a>
                            </div>
                        </div>


                        <div v-for="item in searchResultFiltered">
                            <SearchResult :item="item"></SearchResult>
                        </div>
                    </div>

                    <!-- Meter Tree Tile -->
                    <div class="box">
                        <!-- dimension select -->
                        <div class="field has-addons">
                            <p class="control">
                                <p class="button is-primary is-small is-secondary primary"> Dimension </p>
                                <p>
                                    <p class="control">
                                        <div class="select is-small">
                                            <select v-model="selectedUserDimension">
                                                <option v-for="(dimension,index) in userDimensions" :value="dimension.id"
                                                    v-bind:selected="index===0">{{dimension.name}}</option>
                                            </select>
                                        </div>

                        </div>


                        <!-- Meter tree -->

                        <treemenu :nodes="this.$store.getters.tree.nodes" :key="this.$store.getters.tree.id" :depth="0"
                            :name="this.$store.getters.tree.name" :id="this.$store.getters.tree.id" :type="this.$store.getters.tree.type"
                            :expandable="this.$store.getters.tree.expandable"></treemenu>
                    </div>
                </div>



                <!-- Right side Tiles -->
                <div class="column">
                    <!-- horizontal level for dates-->
                    <div class="box">

                        <div class="field is-grouped is-grouped-multiline">
                         

                            <div class="field extra-space">
                                <p class="control">
                                    <label class="label">Start Time: (DD.MM.YYYY HH:mm:ss in local time) </label>
                                    <input class="input is-small shift-up" type='text' v-model="localStartTimeStamp">
                                </p>
                            </div>
                            <div class="field extra-space">
                                <p class="control">
                                    <label class="label"> End Time: (DD.MM.YYYY HH:mm:ss in local time) </label>
                                    <input class="input is-small shift-up" type='text' v-model="localEndTimeStamp">
                                </p>
                            </div>


                        </div>






                        <!-- selected meters-->
                        <!-- Meters: <input class="input is-small" type='text' v-model="meterDataIdArray"></input>-->
                        <p><b>Meters to Delete:</b></p>
                        <div v-for="meter in this.$store.getters.meterDataIdNameArray">
                            <div class="meter-list-graph-item " v-if="meter.loaded">
                                <font color="green">{{meter.name}} {{meter.id}} {{meter.unit}} </font>
                            </div>
                            <div class="meter-list-graph-item " v-else>
                                {{meter.name}} {{meter.id}} {{meter.unit}}
                            </div>
                        </div>

                        <br>

                        <!-- horizontal level for control buttons-->
                        <div class="field is-grouped is-grouped-multiline">
                        
                            <p class="control">
                                <button class="button is-dark" @click="deleteData">Delete Data</button>
                            </p>
                            <p class="control">
                                <button class="button is-warning" @click="clearMeters">Clear Meters</button>
                            </p>

                        </div>
                    </div>


                    <div class="box">
                        <!-- charts -->
                        <div v-for="chart in charts">
                            <ReactiveChart :chart="chart"></ReactiveChart>
                        </div>
                    </div>

                </div>
            </div>




        </section>

        <!-- end of app -->
    </div>
</template>

<script>

import treemenu from '@/components/TreeMenu';
import LoadingComponent from '@/components/LoadingComponent';
import ReactiveChart from '@/components/ReactiveChart';
import SearchResult from '@/components/SearchResult';
import MeterComponent from '@/components/MeterComponent';
import LogoutComponent from '@/components/LogoutComponent';
import moment from 'moment';
import _ from 'lodash';
import saveAs from 'file-saver';
import NavbarComponent from '@/components/NavbarComponent.vue'

//VUE ROOT remove password when ready
export default {
	name: 'navigatorDataDashboard',
    components: {treemenu, LoadingComponent, SearchResult, ReactiveChart, MeterComponent, LogoutComponent, NavbarComponent},
        // Empty data array to initialise this.$axios data into
        data: function() { return { 
            concurrent_requests_limit:10,
            devices: [],
        	currentTime: '',
            proxyurl: this.$store.getters.proxyurl,
        	filterLocation: 'NSW',
        	username: this.$store.getters.navigatorUsername,
        	password: this.$store.getters.navigatorPassword, //remove password when ready!
            userId: this.$store.getters.navigatorUserId,
            loggedInStatus: false,
            lastSelectedTreeId: '',
            lastSelectedTreeName: '',
            userDimensions: [],
            selectedUserDimension:'16', //default to technical for now
        	tree: {id:'450867',name:'Siemens Australia',nodes:[],type:'NODE',expandable:true},
            treeShowChildrenArray:[],
        	nodeRetrievedList:[],
        	loading: false,
            meterData:[],
            meterDataIdArray: [],
            meterDataIdNameArray:[],                
            localStartTimeStamp: moment().subtract(7,'days').startOf('day').format("DD.MM.YYYY HH:mm:ss"),
            localEndTimeStamp:  moment().startOf('day').format("DD.MM.YYYY HH:mm:ss"),
            selectedTimeRange: 'Last 7 days',
            //utcStartTimeStamp:'10.10.2018 00:00:00',
            //utcEndTimeStamp:'10.01.2019 02:00:00',
        	charts: [],
            includeRangeSlider: true,
            autoGraphData: true,
            searchString: 'Search in highlighted Node',
            searchFilter: '',
            searchResult:[],
            
        }
    },
    computed: {
        	filteredDevices(){
                    return this.devices.filter(device => device.location.includes(this.filterLocation)); //filter all tasks not completed
                },
                
            //convert the local timestamps to utc timestamps to be used by Navigator API calls (all in UTC) the data is then later transformed back to local time in the graphs   
            utcStartTimeStamp(){
                return moment(this.localStartTimeStamp,"DD.MM.YYYY HH:mm:ss").utc().format("DD.MM.YYYY HH:mm:ss");
            },
            utcEndTimeStamp(){
                return moment(this.localEndTimeStamp,"DD.MM.YYYY HH:mm:ss").utc().format("DD.MM.YYYY HH:mm:ss");
            },
            searchResultFiltered(){ //search Result Filter whenever new searchResult or searchFilter changes
                let filteredList = [];
                
                //create array of filter terms split by *
                let filterWordsArray = this.searchFilter.split('*');
                
                //If list is nothing, then do nothing
                if(this.searchResult.list == null){
                    return null;
                }else{
                
                //Otherwise get all the meter objects          
                this.searchResult.list.forEach((item)=>{
                    if(item.treeObjectType == 'METER'){
                        filteredList.push(item);
                    }
                });
                
                //for each filter word
                filterWordsArray.forEach((word)=>{
                //update the filteredList to contain only meters with names that include the filter word    
                filteredList = filteredList.filter(item=>item.name.toUpperCase().includes(word.toUpperCase()));
                });
                
                return filteredList;
                }
            },
           
            },
            methods: {
            	
        //Updates Current Time Method
        updateCurrentTime() {
        	this.currentTime = moment().format('LTS')
        },
        
        changeTitle() {
        	this.charts[0].layout.title='changed';
        },
        
        //Add data to graph
        addData: function() {
        },
        
        //loginto Navigator check and get userId
        loginNavigator(){
             this.loading=true;
             const url = this.proxyurl + "https://eadvantage.siemens.com/remote/release/users/current"
             
             //return for the async await
              return this.$axios({ method: 'get',url: url,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded',}
            }).then(response => {
                
                this.userId = response.data.id;
                this.loggedInStatus = true;
                 this.loading=false;
                 
               }).catch(error => {
                        console.log(error)
                        this.loggedInStatus = false;
                        this.loading=false;

                }); 
        },
        getUserDimensions(){
            this.loading=true;
             const url = this.proxyurl + "https://eadvantage.siemens.com/remote/release/users/" + this.userId.toString() + "/dimensions";
             
             //return for the async await
                 return this.$axios({ method: 'get',url: url,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded',}
            }).then(response => {
                response.data.forEach((dimension)=>{
                this.userDimensions.push({id: dimension.id, name: dimension.name});
                });
                 this.loading=false;
                 
               }).catch(error => {
                        console.log(error)
                        this.loading=false;
                });
                
        },
        //update metertree root with user selected dimension
        updateMeterTreeRoot(){
             this.loading=true;
             const url = this.proxyurl + "https://eadvantage.siemens.com/remote/release/tree/user/" + this.userId.toString() + "/dimension/" + this.selectedUserDimension.toString() + '/root';
             
             //return for the async await
                 return this.$axios({ method: 'get',url: url,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded',}
            }).then(response => {

                //base node of tree equals the response data
                this.$store.commit('changetree',{id: response.data.id, name: response.data.name, nodes: [], type:response.data.treeObjectType, expandable: response.data.expandable });
                this.$store.commit('changelastSelectedTreeId',response.data.id);
                this.$store.commit('changelastSelectedTreeName',response.data.name);
                //empty node retreived list
                this.$store.commit('changenodeRetrievedList',[]);
                this.$store.commit('changetreeShowChildrenArray',[]); //empty tree as well
                 this.loading=false;
                 
               }).catch(error => {
                        console.log(error)
                        this.loading=false;
                });
                
        },
        
        //initial load method, with async methods so each function waits for the previous one to finish
        async initialLoad() {
              await this.loginNavigator();
              await this.getUserDimensions();
              await this.updateMeterTreeRoot();
        },
        
        //search Navigator for meters/nodes with the last selected Node
        searchNavigator() {

             this.loading=true;
            //Navigator devices API url
            const url = this.proxyurl + "https://eadvantage.siemens.com/remote/release/tree/user/" + this.$store.getters.navigatorUserId.toString() +"/node/" + this.$store.getters.lastSelectedTreeId.toString() + "/search?searchstring=" + this.searchString.toString();

            this.$axios({ method: 'get',url: url,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded',}
            }).then(response => {
                
            	this.searchResult = response.data;
                 this.loading=false;
        }).catch(error => { 
        this.loading=false;
                        console.log(error)             
                        });  
        
        },
        getIntialNodes(meterId){
        	
        	this.showChildren = !this.showChildren;
            //Navigator devices API url
            //requires userId, starttime and endtime in unix (with milliseconds)
            //using CORS proxy to bypass the No Access-Control-Allow-Origin header in server
            //see https://gist.github.com/jesperorb/6ca596217c8dfba237744966c2b5ab1e for more details on how to handle CORs client-side
            var url = this.proxyurl + "https://eadvantage.siemens.com/remote/release/tree/user/" + this.userId.toString() + "/node/" + meterId + "/children";              
            
            this.$axios({ method: 'get',
            	url: url,
            	headers: {
            		'Accept': 'application/json',
            		'Content-Type': 'x-www-form-urlencoded',
            	},
            	
            }).then(response => {                
            //set this Vue instance devices data with the formatted reponse data
            
            var step;
            //iterate through whole data array
            for (step = 0; step < response.data.length; step++) {
            	this.tree.nodes.push({name:response.data[step].name, id:response.data[step].id, nodes:[]});
            	
            }
        })
        },
        addSearchMeters(){

                 let meterDataIdArray = this.$store.getters.meterDataIdArray;
            let meterDataIdNameArray = this.$store.getters.meterDataIdNameArray;
            this.searchResultFiltered.forEach((meter)=>{
       
                if(meterDataIdArray.includes(meter.id.split('-')[1]) === false){    //check if meter is not already in the meter data id array 
            meterDataIdArray.push(meter.id.split('-')[1]);
            meterDataIdNameArray.push({id: meter.id.split('-')[1], name: meter.name, loaded:false, unit: ''} );
            
                }
            });
            this.$store.commit('changemeterDataIdArray',meterDataIdArray);
            this.$store.commit('changemeterDataIdNameArray',meterDataIdNameArray);    
                
        },
        clearMeters(){
            this.$store.commit('changemeterDataIdArray',[]);
            this.$store.commit('changemeterDataIdNameArray',[]);
        },
        
        setDates(range){
            
            if(range.toUpperCase() === "LAST 24 HOURS"){
               this.localStartTimeStamp = moment().subtract(1, "days").format("DD.MM.YYYY HH:mm:ss");
               this.localEndTimeStamp = moment().format("DD.MM.YYYY HH:mm:ss");   
            }
            else if(range.toUpperCase() === "YESTERDAY"){
                this.localStartTimeStamp = moment().subtract(1,'days').startOf('day').format("DD.MM.YYYY HH:mm:ss");
                 this.localEndTimeStamp = moment().startOf('day').format("DD.MM.YYYY HH:mm:ss");   
            } 
            else if(range.toUpperCase() === "LAST 7 DAYS"){
                 this.localStartTimeStamp = moment().subtract(7,'days').startOf('day').format("DD.MM.YYYY HH:mm:ss");
                 this.localEndTimeStamp = moment().startOf('day').format("DD.MM.YYYY HH:mm:ss");   
            }
            else if(range.toUpperCase() === "LAST 14 DAYS"){
                 this.localStartTimeStamp = moment().subtract(14,'days').startOf('day').format("DD.MM.YYYY HH:mm:ss");
                 this.localEndTimeStamp = moment().startOf('day').format("DD.MM.YYYY HH:mm:ss");   
            }             
            else if(range.toUpperCase() === "LAST 30 DAYS"){
                this.localStartTimeStamp = moment().subtract(30,'days').startOf('day').format("DD.MM.YYYY HH:mm:ss");
                 this.localEndTimeStamp = moment().startOf('day').format("DD.MM.YYYY HH:mm:ss");   
            } 
            else if(range.toUpperCase() === "LAST 3 MONTHS"){  
                this.localStartTimeStamp = moment().subtract(3,'months').startOf('day').format("DD.MM.YYYY HH:mm:ss");
                 this.localEndTimeStamp = moment().startOf('day').format("DD.MM.YYYY HH:mm:ss");               
            } 
            else if(range.toUpperCase() === "LAST YEAR"){
                this.localStartTimeStamp = moment().subtract(1,'years').startOf('day').format("DD.MM.YYYY HH:mm:ss");
                 this.localEndTimeStamp = moment().startOf('day').format("DD.MM.YYYY HH:mm:ss");  
            }
            else if(range.toUpperCase() === "YEAR TO DATE"){
                this.localStartTimeStamp = moment().startOf('year').format("DD.MM.YYYY HH:mm:ss");
                 this.localEndTimeStamp = moment().startOf('day').format("DD.MM.YYYY HH:mm:ss");  
               
            }
        },
          
          
          async deleteData(){
          this.loading=true;
          if (confirm("WARNING! There is no returning data if you press OK. Please make sure you know what you are doing.")) {
                 let meterIDsArray = this.$store.getters.meterDataIdArray.toString().split(',');
                 let meterStructureLength = this.$store.getters.meterDataIdArray.length;
                let concurrent_requests = this.concurrent_requests_limit;  //number of concurrent requests to send at a time
                    
                    //get all urls to delete readings, but do it in batches
                    
                    for (let i = 0; i< meterStructureLength/concurrent_requests; i++){
                    await Promise.all(meterIDsArray.slice(0+i*concurrent_requests,(i+1)*concurrent_requests).map(async (meter, index)  => {
    
                                console.log ("Deleting " + meter)
                                var url = this.proxyurl + "https://eadvantage.siemens.com/remote/release/meter/"+meter+"/readings?utcStartTimestamp="+this.utcStartTimeStamp+"&utcEndTimestamp="+this.utcEndTimeStamp;

                 await this.$axios({method: 'delete',url: url,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded',}})
                .then((response) => {
                console.log("Done deleting " + meter)
                return Promise.resolve('ok') ;
    
       
                }).catch((error) => {
                    console.log(error)
                });
                        
                    })
                    )
                    }
       
                alert("Done!")
               
              }
               this.loading=false;

          
          },
          
    
        

    },
    
        //Mounted Stage
        mounted() {
        //this.loginNavigator();
        this.initialLoad();
        	
            //add mock data to chart
            /*for (let i = 0; i < 100; i++) {
            	this.addData();
            }*/
            
        //this.$axios http get request with username passwor authentication to Navigator API
        //setInterval(() => this.updateDevices(), 5* 60 * 1000)  
    },


          //Created Stage
          created() {
          },
          watch: {
              
              //when selected User dimension changes, then get new tree node/meter root data
              selectedUserDimension: function(val){
                   this.updateMeterTreeRoot();
                },
                selectedTimeRange: function(val){
                    this.setDates(val);
                },
          }
      };
      
      
     

     
  </script>
  
  
  <style scoped>
  
  
      .column.scroll {
        overflow-x: hidden;
        overflow-y: hidden;
        white-space: wrap;
  
      
      }
      
      .level-item {
        flex-shrink: 1;
        padding-right: 10px;
        }
        
      .field.extra-space {
        padding-right: 30px;
        }
        
      .search-result-item {
        font-size:0.8em;
        }
        
      .meter-list-graph-item {
        font-size:0.8em;
        }
       
       .navbar-text {
            position: absolute;
            font-size:2em;
            width: 100%;
            left: 0;
            text-align: left;
            margin: auto;
            margin-top: -0.4em;
            padding-left: 1em;
        }
        
        .loading {
            position: absolute;
            font-size:1em;
            width: 100%;
            size: 10%;
           padding-top: 4px;
            left: 0;
            text-align: center;
            margin: auto;
        }
       
               
        label.stack{  
            width:200px;       

            display:inline-block;    
            vertical-align:middle; 
        }
            
        .meter-selected{
        color:blue;
        }     

        .node-selected{
        background-color:#0d5a60;
        color:white;
        }
        
        
    .button.is-primary {
       background-color:#000028;
        color:white;
        }       
       
       .button.is-primary:hover{
         background-color:#000028;
           color:white;
       }
       
       
       

       .button.is-primary:active{
         background-color:#002949;
           color:white;
       }
       
          .section {
  margin-top: -3em;
  padding-top :-3px
}
    
                   .section{
          padding:5px;
          margin:5px;
      }
      .column{
      height:calc(100vh - 50px);
      overflow-y: auto;
      overflow-x: hidden;
      white-space: wrap;
  }   
  </style>